export default "__VITE_ASSET__Dzt9xvqU__"